import { useCallback, useEffect, useState } from "react";
import { api, formatApiErrorDetail, nivelInfo } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Palette, Check, X } from "lucide-react";

/** Bandeja de cambios de nivel propuestos por los profesores (aprueba admin o franquiciado). */
export const SolicitudesNivel = ({ onResuelta }) => {
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    api.get("/nivel-solicitudes?estado=pendiente")
      .then(({ data }) => setItems(data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const resolver = async (id, aprobar) => {
    try {
      await api.post(`/nivel-solicitudes/${id}/resolver`, { aprobar });
      toast.success(aprobar ? "Nivel actualizado" : "Solicitud rechazada");
      load();
      onResuelta?.();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  if (items.length === 0) return null;

  return (
    <Card className="rounded-2xl p-6 mb-7 border-primary/40 bg-accent/30 shadow-sm"
      data-testid="solicitudes-nivel">
      <div className="flex items-center gap-2 mb-4">
        <Palette className="h-5 w-5 text-primary" />
        <h3 className="font-display text-lg font-bold">
          Cambios de nivel pendientes ({items.length})
        </h3>
      </div>
      <div className="space-y-3">
        {items.map((s) => (
          <div key={s.id} className="rounded-xl border border-border bg-background p-4 flex flex-wrap items-center justify-between gap-3"
            data-testid={`solicitud-nivel-${s.id}`}>
            <div>
              <p className="font-semibold text-sm">
                {s.alumno} · {nivelInfo(s.nivel_actual).label} → {nivelInfo(s.nivel_nuevo).label}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {s.motivo} — pedido por {s.solicitado_por}
              </p>
            </div>
            <div className="flex gap-2">
              <Button size="sm" className="rounded-full font-semibold"
                onClick={() => resolver(s.id, true)} data-testid={`aprobar-nivel-${s.id}`}>
                <Check className="h-4 w-4 mr-1.5" /> Aprobar
              </Button>
              <Button size="sm" variant="outline" className="rounded-full text-destructive"
                onClick={() => resolver(s.id, false)} data-testid={`rechazar-nivel-${s.id}`}>
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
